export default "__VITE_ASSET__$_PKhNTZ__"